export default function TextSubtitle({ children }: { children: React.ReactNode }) {
    return (<>
        <span className="text-subtitle">
            {children}
        </span>
    </>)
}